module.exports = __webpack_public_path__ + "static/5-f87bcfbb1347b902e32e5ba439f6f4c0.jpg";